import React from 'react';

import styled from 'styled-components';

import { brandFont } from 'components/layout/brand-font';

import { IHeroSuperText } from './types';
import { getColorForSanityHeroTextColor } from './utils';

const SuperText = styled.h1`
  font: ${brandFont.headerOne};
  color: ${p => p.theme.token('text-reversed')};
  letter-spacing: normal;
  line-height: 90%;
  text-align: center;
  width: 100%;
  text-shadow: 0 3px 7px rgb(80, 35, 20);
  margin-block-start: 0;
  margin-block-end: 0;

  ${Styles.desktop} {
    font-size: calc(10rem / 3);
    text-align: start;
  }
`;

const SanityHeroSuperText = styled(SuperText)<IHeroSuperText>`
  color: ${({ sanityTextColor, defaultTextColor }) =>
    getColorForSanityHeroTextColor(sanityTextColor, defaultTextColor)};
`;

export const HeroSuperText: React.FC<IHeroSuperText> = ({ children, ...props }) => {
  return <SanityHeroSuperText {...props}>{children}</SanityHeroSuperText>;
};
